import { AbstractControl, ValidatorFn } from '@angular/forms';

export class NotInListValidator {
  public static notInListValidator(invalidOptions: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const controlValue = `${control.value ?? ''}`.trim();
      const valid = !invalidOptions.includes(controlValue);

      return !valid ? { notInList: { value: control.value } } : null;
    };
  }
}
